import { render, staticRenderFns } from "./RequestCall.vue?vue&type=template&id=63745aa0&scoped=true&"
import script from "./RequestCall.vue?vue&type=script&lang=js&"
export * from "./RequestCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63745aa0",
  null
  
)

export default component.exports